import { type FC } from 'react';

import { useCompleteContractMutation } from '@/api/queries/contract';
import { useSpecContractItem } from '@/common/hooks/contract';
import { type ContractDataType } from '@/common/types/contract';
import { ContractItemAnimationWrapper } from '@/components/Home/Contracts/ContractItemAnimationWrapper/ContractItemAnimationWrapper';

import { SpecContractItem } from '../SpecContractItem/SpecContractItem';

interface ActiveSpecContractItemProps extends ContractDataType {
  onlyActive?: boolean;
}

const ActiveSpecContractItem: FC<ActiveSpecContractItemProps> = ({
  onlyActive,
  ...contract
}) => {
  const { status, ...props } = useSpecContractItem(contract);
  const [, { isUninitialized }] = useCompleteContractMutation({
    fixedCacheKey: 'shared-complete-contract',
  });

  return (
    status && (
      <ContractItemAnimationWrapper isUninitialized={isUninitialized}>
        <SpecContractItem {...props} status={status} />
      </ContractItemAnimationWrapper>
    )
  );
};

export { ActiveSpecContractItem };
